import React, { useEffect, useState } from "react";
import {
    ArrowLeftOutlined,
    UserOutlined,
    FileTextOutlined,
    FilePdfOutlined,
    SendOutlined,
    DollarOutlined,
    PlusCircleOutlined,
    WhatsAppOutlined,
    DownloadOutlined,
    PrinterOutlined,
    ShareAltOutlined,
    SyncOutlined,
    DownOutlined,
} from "@ant-design/icons";
import { Card, Flex, Select, DatePicker, Row, Col, Form, Button, Typography, Input, Space, Dropdown } from "antd";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import { UserService } from "../../../Services/Manage/UserService";
import useMessage from "antd/es/message/useMessage";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import dayjs from "dayjs";
import AddInvoiceData from "./AddInvoiceData";
import { InvoiceService } from "../../../Services/Manage/InvoiceService";

// add at top imports
import InvoiceProfessionalTemplate from "../template/InvoiceProfessionalTemplate";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { LetterService } from "../../../Services/Manage/LetterService";

const { Option, OptGroup } = Select;
const { Text } = Typography;
const primaryColor = "rgba(11, 93, 148, 0.95)";



// Inline label : value row — matches the reference image (Customer Information / Invoice Details)
const InfoRow = ({ label, value, valueNode, last }) => (
    <div
        style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: last ? 0 : 12,
            fontSize: 13,
        }}
    >
        <span style={{ width: 110, color: "#6b7280", flexShrink: 0 }}>{label}</span>
        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
        {valueNode ? valueNode : <span style={{ fontWeight: 600, color: "#1f1f1f" }}>{value || "-"}</span>}
    </div>
);

// input row used in edit mode — same label width/alignment as InfoRow
const EditRow = ({ label, children }) => (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>{label}</span>
        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
        <div style={{ flex: 1 }}>{children}</div>
    </div>
);

const InfoItem = ({ label, value }) => (
    <div>
        <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
            {label}
        </div>
        <div style={{ color: "#111827", fontSize: 14, fontWeight: 700, lineHeight: 1.5, minHeight: 24 }}>
            {value || "-"}
        </div>
    </div>
);

const CreateInvoice = () => {
    const [data, setData] = useState([]);
    const [message, msgConxt] = useMessage();
    const [eqData, setEqData] = useState([]);
    const [form] = Form.useForm();
    const [in_gen, setIn_gen] = useState([]);
    const [Eqslected, seEQSelect] = useState(true);
    const [baseData, setBasedata] = useState([]);
    const [customerForm] = Form.useForm();
    const [rowData, setRowData] = useState([]);
    const [selectMode, setSelectMode] = useState(null);
    const [enquiryList, setEnquiryList] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [dueDate, setDueDate] = useState("");
    const [invoiceStatus, setInvoiceStatus] = useState("Draft");
    const [invoiceRecord, setInvoiceRecord] = useState(null);
    const [userMap, setUserMap] = useState({});
    const [letterHead, setLetterHead] = useState([]);
    const [paymentSummary, setPaymentSummary] = useState({ grandTotal: 0, totalReceived: 0 });
    // ---- Customer Information edit state ----
    const [editCustomer, setEditCustomer] = useState(false);
    const [customerInfo, setCustomerInfo] = useState({
        company_name: "",
        contact_person: "",
        mobile_no: "",
        email: "",
        gstin: "",
        address: "",
    });

    // ---- Invoice Details edit state ----
    const [editInvoiceDetails, setEditInvoiceDetails] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState({
        invoice_date: dayjs().format("YYYY-MM-DD"),
        due_date: "",
        reference: "",
        project: "",
        place_of_supply: "",
        status: "Draft",
        sales_executive: "",
    });

    useEffect(() => {
        setCustomerInfo({
            company_name: eqData?.company_name || eqData?.name || "",
            contact_person: eqData?.contact_person || eqData?.name || "",
            mobile_no: eqData?.mobile_no || eqData?.contact_whatsapp || "",
            email: eqData?.email || eqData?.contact_email || "",
            gstin: eqData?.gstin || "",
            address: eqData?.address || eqData?.location_city || "",
        });
        setEditCustomer(false);
    }, [eqData]);

    useEffect(() => {
        customerForm.setFieldsValue({
            name: customerInfo.company_name || customerInfo.contact_person || "",
            mobile_no: customerInfo.mobile_no || "",
            address: customerInfo.address || "",
            gstin: customerInfo.gstin || "",
            email: customerInfo.email || "",
        });
    }, [customerInfo, customerForm]);

    useEffect(() => {
        const fallbackUser = (() => {
            try {
                const u = JSON.parse(localStorage.getItem("ome_user") || "{}");
                return u?.name || u?.user_name || "";
            } catch { return ""; }
        })();

        const creatorUid = String(eqData?.addedby ?? eqData?.added_by ?? "").trim();
        const creatorName = userMap[creatorUid] || (eqData?.added_by && !userMap[creatorUid] ? eqData.added_by : "");
        const resolvedExec = eqData?.assigned_to || creatorName || fallbackUser;

        setInvoiceDetails((p) => ({
            ...p,
            invoice_date: invoiceDate,
            due_date: dueDate,
            status: invoiceStatus,
            reference: eqData?.qu_no || eqData?.eq_id || "",
            project: eqData?.project_name || eqData?.eq_description || p.project || "",
            place_of_supply: eqData?.place_of_supply || eqData?.location_city || p.place_of_supply || "",
            sales_executive: resolvedExec,
        }));
    }, [invoiceDate, dueDate, invoiceStatus, eqData, userMap]);

    const saveCustomerInfo = async () => {
        setEqData((prev) => ({
            ...prev,
            company_name: customerInfo.company_name,
            name: customerInfo.company_name,
            contact_person: customerInfo.contact_person,
            mobile_no: customerInfo.mobile_no,
            contact_whatsapp: customerInfo.mobile_no,
            email: customerInfo.email,
            contact_email: customerInfo.email,
            gstin: customerInfo.gstin,
            address: customerInfo.address,
            location_city: customerInfo.address,
        }));
        setEditCustomer(false);

        if (invoiceRecord?.qu_no && !eqData?.eq_id) {
            try {
                await InvoiceService.updateCustomer(
                    {
                        name: customerInfo.company_name || customerInfo.contact_person,
                        mobile_no: customerInfo.mobile_no,
                        address: customerInfo.address,
                    },
                    invoiceRecord.qu_no
                );
            } catch (e) { console.error(e); }
        }
    };

    const saveInvoiceDetails = async () => {
        setInvoiceDate(invoiceDetails.invoice_date);
        setDueDate(invoiceDetails.due_date);
        setEditInvoiceDetails(false);
        if (invoiceRecord?.id) {
            try {
                await InvoiceService.updateInvoice(
                    {
                        due_date: invoiceDetails.due_date || null,
                        reference: invoiceDetails.reference || null,
                        project: invoiceDetails.project || null,
                        place_of_supply: invoiceDetails.place_of_supply || null,
                        sales_executive: invoiceDetails.sales_executive || null,
                    },
                    invoiceRecord.id
                );
            } catch (e) { console.error(e); }
        }
    };

    const groupedEnquiries = enquiryList.reduce((acc, item) => {
        if (!acc[item.service_id]) {
            acc[item.service_id] = { service_name: item.service_name, items: [] };
        }
        acc[item.service_id].items.push(item);
        return acc;
    }, {});

    const getAllQotationProjects = async () => {
        try {
            const user = await UserService.getOmeUser();
            let viewAll = false;
            try {
                const raw = localStorage.getItem("ome_permission");
                const parsed = JSON.parse(raw);
                const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
                const p = permissions.find((x) => x.link === "/invoice");
                viewAll = p?.view_all === true;
            } catch { }

            const request = await QuotationService.getAllQuotation();
            let rows = (request.data || []).filter(
                (q) => (q.quotation_status || "").toLowerCase() === "converted"
            );

            if (!viewAll) {
                const omeUser = JSON.parse(localStorage.getItem("ome_user") || "{}");
                const userName = omeUser?.name || omeUser?.user_name || "";
                rows = rows.filter(q => {
                    const assigned = (q.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
                    const isAssigned = assigned.includes(userName);
                    const isCreator = String(q.added_by ?? "").trim() === String(user.uid).trim();
                    return isAssigned || isCreator;
                });
            }

            setData(rows);
        } catch (error) {
            console.error(error);
        }
    };

    const [orgDetails, setOrgDetails] = useState(null);

    const loadOrgDetails = async () => {
        try {
            const res = await LetterService.getAllFooter();
            setOrgDetails((res.data || [])[0] || null);
        } catch (e) { console.error(e); }
    };

    useEffect(() => {
        getAllQotationProjects();
        getAllEnquiries();
        handleGenerateInvoice();
        loadUserMap();
        loadOrgDetails();
        LetterService.getAllHead().then(res => setLetterHead(res.data || [])).catch(console.error);


    }, []);
    const loadUserMap = async () => {
        try {
            const res = await UserService.getAllUsers();
            const list = res?.data || res || [];
            const map = {};
            list.forEach((u) => {
                const uid = u.uid || u.user_id || u.id;
                const nm = u.name || u.user_name || u.username;
                if (uid && nm) map[String(uid).trim()] = nm;
            });
            setUserMap(map);
        } catch (e) { console.error(e); }
    };

    const getAllEnquiries = async () => {
        try {
            const user = await UserService.getOmeUser();
            let viewAll = false;
            try {
                const raw = localStorage.getItem("ome_permission");
                const parsed = JSON.parse(raw);
                const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
                const p = permissions.find((x) => x.link === "/enquiry");
                viewAll = p?.view_all === true;
            } catch { }

            const request = await EnquiryService.getAllEnquiries();
            let rows = request.data || [];

            if (!viewAll) {
                const omeUser = JSON.parse(localStorage.getItem("ome_user") || "{}");
                const userName = omeUser?.name || omeUser?.user_name || "";
                rows = rows.filter(d => {
                    const assigned = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
                    const isAssigned = assigned.includes(userName);
                    const isCreator = String(d.addedby ?? "").trim() === String(user.uid).trim();
                    return isAssigned || isCreator;
                });
            }

            const { ConfigurationService } = await import('../../../Services/Manage/ConfigurationService');
            const res = await ConfigurationService.getByType("enquiry_status");
            const moveToQuotationStatuses = (res.data || [])
                .filter(s => s.move_to_quotation)
                .map(s => s.label.trim());

            rows = rows.filter(d => moveToQuotationStatuses.includes((d.eq_status || "").trim()));

            setEnquiryList(rows);
        } catch (error) {
            console.error(error);
        }
    };

    const renderItem = (eqId, name) => (
        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
            <span>{eqId}</span>
            <span>
                <UserOutlined /> {name}
            </span>
        </Flex>
    );

    const grouped = data.reduce((acc, item) => {
        if (!acc[item.service_id]) {
            acc[item.service_id] = { service_name: item.service_name, items: [] };
        }
        acc[item.service_id].items.push(item);
        return acc;
    }, {});

    const handleGetDatabyEqid = async (value) => {
        try {
            const request = await EnquiryService.getEnquiryDetailsById(value);
            if (request.status) {
                setEqData(request.data);
                seEQSelect(true);
            } else {
                console.log(request.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleGenerateInvoice = async () => {
        try {
            const request = await InvoiceService.getLastInvoice();

            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = String(now.getFullYear()).slice(-2);
            const prefix = `${day}${month}${year}`;

            let newSeq = "001";

            if (request.status && request.data && request.data.invoice_no) {
                const seqPart = request.data.invoice_no.split("-").pop();
                const parsed = parseInt(seqPart, 10);
                if (!isNaN(parsed)) {
                    newSeq = String(parsed + 1).padStart(3, "0");
                }
            }

            const newInvoiceNo = `${prefix}-${newSeq}`;
            setIn_gen(newInvoiceNo);
            form.setFieldsValue({ invoice_no: newInvoiceNo });
            return newInvoiceNo;
        } catch (error) {
            console.error(error);

            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = String(now.getFullYear()).slice(-2);
            const fallbackInvoiceNo = `${day}${month}${year}-001`;
            return fallbackInvoiceNo;
        }
    };

    const handleSelectEnquiry = async (value) => {
        try {
            if (!value) {
                setEqData([]);
                setBasedata([]);
                setRowData([]);
                customerForm.resetFields();
                return;
            }
            await handleGenerateInvoice();
            const request = await EnquiryService.getEnquiryDetailsById(value);
            if (request.status) {
                setEqData(request.data);
                setBasedata({});
                setRowData([]);
                seEQSelect(true);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleGetDataByQId = async (value) => {
        try {
            await handleGenerateInvoice();
            await handleGetDatabyEqid(value);
            const request = await QuotationService.getAllQuotationById(value);

            setRowData(request.data.quotation_data);
            setBasedata(request.data.quotation);
            const quotation = request.data.quotation;
            const isManual = quotation?.eq_no === quotation?.qu_no;
            const quAssignedTo = quotation?.assigned_to || "";
            const quAddedBy = quotation?.prepared_by || "";
            const quAddedByUid = quotation?.added_by || "";

            if (isManual) {
                const cust = request.data.customer || {};
                setEqData({
                    name: cust.name,
                    company_name: cust.company_name,
                    mobile_no: cust.mobile_no,
                    address: cust.address,
                    eq_id: quotation.eq_no,
                    qu_no: quotation.qu_no,
                    assigned_to: quAssignedTo,
                    added_by: quAddedBy,
                    addedby: quAddedByUid,
                });
                customerForm.setFieldsValue({
                    name: cust.name,
                    mobile_no: cust.mobile_no,
                    address: cust.address,
                    note: cust.note,
                });
            } else {
                const request_2 = await QuotationService.getEqCustomerByQId(value);
                setEqData({
                    ...request_2.data,
                    assigned_to: quAssignedTo || request_2.data?.assigned_to || "",
                    added_by: quAddedBy || request_2.data?.added_by || "",
                    addedby: quAddedByUid || request_2.data?.addedby || "",
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleNewInvoice = () => {
        setEqData({});
        seEQSelect(false);
        setBasedata([]);
        setRowData([]);
        setDueDate("");
        setInvoiceStatus("Draft");
        setInvoiceDate(dayjs().format("YYYY-MM-DD"));
        customerForm.resetFields();
        handleGenerateInvoice();
    };

    const statusColors = {
        Draft: { bg: "#fef3c7", color: "#b45309" },
        Created: { bg: "#e0edff", color: "#2563eb" },
        Sent: { bg: "#e0edff", color: "#2563eb" },
        "Paid Partially": { bg: "#dcfce7", color: "#16a34a" },
        Paid: { bg: "#dcfce7", color: "#16a34a" },
        Overdue: { bg: "#fee2e2", color: "#dc2626" },
    };

    // Status is computed, not manually picked.
    const computeStatus = () => {
        // Not yet generated at all — stays Draft no matter what.
        if (!invoiceRecord?.id) return "Draft";

        const baseStatus = invoiceRecord?.status || invoiceStatus || "Draft";
        const invoiceVal = Number(paymentSummary.grandTotal || 0);
        const received = Number(paymentSummary.totalReceived || 0);
        const dueDatePassed = dueDate && new Date(dueDate) < new Date();

        if (invoiceVal > 0 && received >= invoiceVal) return "Paid";

        if (received > 0 && received < invoiceVal) {
            return dueDatePassed ? "Overdue" : "Paid Partially";
        }

        if (dueDatePassed && received <= 0) return "Overdue";

        return baseStatus;
    };

    const currentStatus = computeStatus();
    const statusStyle = statusColors[currentStatus] || statusColors.Draft;

    // const moreActionsMenu = {
    //     items: [
    //         { key: "duplicate", label: "Duplicate Invoice" },
    //         { key: "cancel", label: "Cancel Invoice" },
    //         { key: "delete", label: "Delete Invoice" },
    //     ],
    // };

    const getBase64Image = (url) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                canvas.getContext("2d").drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.onerror = reject;
            img.src = url;
        });

    const numberToWords = (num) => {
        const a = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];
        if (num === 0) return "Zero";
        let str = "", grp = 0;
        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let s = "";
                if (chunk > 99) { s += a[Math.floor(chunk / 100)] + " Hundred "; chunk %= 100; }
                if (chunk > 19) { s += b[Math.floor(chunk / 10)] + " "; chunk %= 10; }
                if (chunk > 0) s += a[chunk] + " ";
                str = s + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000); grp++;
        }
        return str.trim();
    };

    const handleDownloadInvoicePDF = async () => {
        try {
            const { BankService } = await import('../../../Services/Manage/BankService');
            let bankAcObj = null;
            if (invoiceRecord?.bank_id) {
                try {
                    const bankRes = await BankService.getAllBank();
                    bankAcObj = (bankRes?.data || []).find(b => Number(b.id) === Number(invoiceRecord.bank_id)) || null;
                } catch (e) { console.error(e); }
            }
            const headerObj = letterHead.find(lh => lh.tag?.toLowerCase() === "header");
            const headerBase64 = headerObj ? await getBase64Image(`${ENDPOINT.base}/${headerObj.image_url}`) : "";

            let dgSignBase64 = "";
            let dgSignAspectRatio = null;
            try {
                if (invoiceRecord?.sign_id) {
                    const signRes = await QuotationService.getDigitalSign();
                    const signObj = (signRes?.data || []).find(s => Number(s.id) === Number(invoiceRecord.sign_id));
                    if (signObj) {
                        dgSignBase64 = await getBase64Image(`${ENDPOINT.base}/${signObj.image_path}`);
                    }
                }
            } catch (e) { console.error(e); }

            if (dgSignBase64) {
                dgSignAspectRatio = await new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve(img.width / img.height);
                    img.onerror = () => resolve(null);
                    img.src = dgSignBase64;
                });
            }

            const footerObj = letterHead.find(lh => lh.tag?.toLowerCase() === "footer");
            const footerBase64 = footerObj ? await getBase64Image(`${ENDPOINT.base}/${footerObj.image_url}`) : "";

            let footerAspectRatio = null;
            if (footerBase64) {
                footerAspectRatio = await new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve(img.width / img.height);
                    img.onerror = () => resolve(null);
                    img.src = footerBase64;
                });
            }

            let paymentHistory = [];
            try {
                const { ExpenseServices } = await import('../../../Services/Manage/ExpenseServices');
                const key = invoiceRecord?.qu_no || in_gen;
                if (key) {
                    const res = await ExpenseServices.getPaymentByQuId(key);
                    paymentHistory = res?.data || [];
                }
            } catch (e) { console.error(e); }

            let invoiceData = [];
            try {
                const key = invoiceRecord?.qu_no || in_gen;
                if (key) {
                    const res = await QuotationService.getAllQuotationById(key);
                    invoiceData = res?.data?.quotation_data || [];
                }
            } catch (e) { console.error(e); }

            const computedGrandTotal = invoiceData.reduce((sum, it) => {
                const qty = Number(it.qty) || 0, rate = Number(it.unitprice) || 0;
                const disc = Number(it.discount) || 0, tax = Number(it.tax) || 0;
                const taxable = qty * rate * (1 - disc / 100);
                return sum + taxable + taxable * (tax / 100);
            }, 0);

            const invoiceObj = {
                invoice_no: in_gen,
                invoice_date: invoiceDetails.invoice_date,
                due_date: invoiceDetails.due_date,
                reference: invoiceDetails.reference,
                project: invoiceDetails.project,
                status: invoiceDetails.status,
                grand_total: invoiceRecord?.grand_total || Math.round(computedGrandTotal),
                tc_content: invoiceRecord?.tc_content || null,
            };

            const enquiryObj = {
                company_name: customerInfo.company_name,
                name: customerInfo.contact_person,
                contact_person: customerInfo.contact_person,
                mobile_no: customerInfo.mobile_no,
                email: customerInfo.email,
                gstin: customerInfo.gstin,
                address: customerInfo.address,
            };

            const pdfDoc = InvoiceProfessionalTemplate({
                invoice: invoiceObj,
                enquiry: enquiryObj,
                invoiceData,
                paymentHistory,
                headerBase64,
                footerBase64,
                footerAspectRatio,
                dgSignBase64,
                dgSignAspectRatio,
                numberToWords,
                bankAc: bankAcObj,
                orgDetails,
            });

            pdfDoc.save(`${in_gen || "Invoice"}.pdf`);
        } catch (e) {
            console.error(e);
            message.error("Failed to generate PDF");
        }
    };

    const buildInvoicePdfDoc = async () => {
        const { BankService } = await import('../../../Services/Manage/BankService');
        let bankAcObj = null;
        if (invoiceRecord?.bank_id) {
            try {
                const bankRes = await BankService.getAllBank();
                bankAcObj = (bankRes?.data || []).find(b => Number(b.id) === Number(invoiceRecord.bank_id)) || null;
            } catch (e) { console.error(e); }
        }
        const headerObj = letterHead.find(lh => lh.tag?.toLowerCase() === "header");
        const headerBase64 = headerObj ? await getBase64Image(`${ENDPOINT.base}/${headerObj.image_url}`) : "";

        let dgSignBase64 = "";
        let dgSignAspectRatio = null;
        try {
            if (invoiceRecord?.sign_id) {
                const signRes = await QuotationService.getDigitalSign();
                const signObj = (signRes?.data || []).find(s => Number(s.id) === Number(invoiceRecord.sign_id));
                if (signObj) {
                    dgSignBase64 = await getBase64Image(`${ENDPOINT.base}/${signObj.image_path}`);
                }
            }
        } catch (e) { console.error(e); }

        if (dgSignBase64) {
            dgSignAspectRatio = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img.width / img.height);
                img.onerror = () => resolve(null);
                img.src = dgSignBase64;
            });
        }

        const footerObj = letterHead.find(lh => lh.tag?.toLowerCase() === "footer");
        const footerBase64 = footerObj ? await getBase64Image(`${ENDPOINT.base}/${footerObj.image_url}`) : "";

        let footerAspectRatio = null;
        if (footerBase64) {
            footerAspectRatio = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img.width / img.height);
                img.onerror = () => resolve(null);
                img.src = footerBase64;
            });
        }

        let paymentHistory = [];
        try {
            const { ExpenseServices } = await import('../../../Services/Manage/ExpenseServices');
            const key = invoiceRecord?.qu_no || in_gen;
            if (key) {
                const res = await ExpenseServices.getPaymentByQuId(key);
                paymentHistory = res?.data || [];
            }
        } catch (e) { console.error(e); }

        let invoiceData = [];
        try {
            const key = invoiceRecord?.qu_no || in_gen;
            if (key) {
                const res = await QuotationService.getAllQuotationById(key);
                invoiceData = res?.data?.quotation_data || [];
            }
        } catch (e) { console.error(e); }

        const computedGrandTotal = invoiceData.reduce((sum, it) => {
            const qty = Number(it.qty) || 0, rate = Number(it.unitprice) || 0;
            const disc = Number(it.discount) || 0, tax = Number(it.tax) || 0;
            const taxable = qty * rate * (1 - disc / 100);
            return sum + taxable + taxable * (tax / 100);
        }, 0);

        const invoiceObj = {
            invoice_no: in_gen,
            invoice_date: invoiceDetails.invoice_date,
            due_date: invoiceDetails.due_date,
            reference: invoiceDetails.reference,
            project: invoiceDetails.project,
            status: invoiceDetails.status,
            grand_total: invoiceRecord?.grand_total || Math.round(computedGrandTotal),
            tc_content: invoiceRecord?.tc_content || null,
        };

        const enquiryObj = {
            company_name: customerInfo.company_name,
            name: customerInfo.contact_person,
            contact_person: customerInfo.contact_person,
            mobile_no: customerInfo.mobile_no,
            email: customerInfo.email,
            gstin: customerInfo.gstin,
            address: customerInfo.address,
        };

        return InvoiceProfessionalTemplate({
            invoice: invoiceObj,
            enquiry: enquiryObj,
            invoiceData,
            paymentHistory,
            headerBase64,
            footerBase64,
            footerAspectRatio,
            dgSignBase64,
            dgSignAspectRatio,
            numberToWords,
            bankAc: bankAcObj,
            orgDetails,
        });
    };

    const handlePrintInvoicePDF = async () => {
        try {
            const pdfDoc = await buildInvoicePdfDoc();
            const blobUrl = pdfDoc.output("bloburl");
            const printWindow = window.open(blobUrl, "_blank");
            if (printWindow) {
                printWindow.addEventListener("load", () => {
                    printWindow.focus();
                    printWindow.print();
                });
            } else {
                message.warning("Please allow pop-ups to print the invoice.");
            }
        } catch (e) {
            console.error(e);
            message.error("Failed to open invoice for printing");
        }
    };

 const handleSendInvoice = async () => {
        if (!invoiceRecord?.id) return message.warning("Generate invoice first before sending.");
        try {
            const pdfDoc = await buildInvoicePdfDoc();
            pdfDoc.save(`${in_gen || "Invoice"}.pdf`);

            await InvoiceService.updateInvoice({ status: "Sent", sent_on: dayjs().toISOString() }, invoiceRecord.id);
            setInvoiceRecord((p) => ({ ...p, status: "Sent", sent_on: dayjs().toISOString() }));
            setInvoiceStatus("Sent");

            const to = encodeURIComponent(customerInfo.email || "");
            const subject = encodeURIComponent(`Invoice ${in_gen}`);
            const body = encodeURIComponent(
                `Hello ${customerInfo.contact_person || customerInfo.company_name || ""},\n\nPlease find attached invoice ${in_gen}.\n\nThank you for your business.`
            );
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`, "_blank");

            message.success("Invoice marked as Sent. PDF downloaded — attach it in Gmail.");
        } catch (e) {
            console.error(e);
            message.error("Failed to send invoice.");
        }
    };

    const handleSendWhatsApp = () => {
        const rawMobile = customerInfo.mobile_no || "";
        const digits = rawMobile.replace(/[^\d]/g, "");
        if (!digits) {
            message.warning("No customer mobile number available.");
            return;
        }
        const phone = digits.length === 10 ? `91${digits}` : digits;
        const text = encodeURIComponent(
            `Hello ${customerInfo.contact_person || customerInfo.company_name || ""}, please find your invoice ${in_gen || ""} for ₹${Number(paymentSummary.grandTotal || 0).toLocaleString("en-IN")}. Thank you for your business.`
        );
        window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
    };

    return (
        <>
            {msgConxt}

            <Card style={{ borderRadius: 12, marginBottom: 12 }} bodyStyle={{ padding: 16 }}>
                {/* Header — buttons exactly matching the reference image */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        marginBottom: 18,
                        flexWrap: "wrap",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <ArrowLeftOutlined
                            style={{ cursor: "pointer", fontSize: 18, color: "#111827" }}
                            onClick={() => window.history.back()}
                        />
                        <Typography.Text style={{ color: primaryColor, fontWeight: 700, fontSize: 16 }}>
                            Invoices
                        </Typography.Text>
                        <Typography.Text style={{ color: "#9ca3af" }}>/</Typography.Text>
                        <Typography.Text style={{ color: primaryColor, fontWeight: 800, fontSize: 16 }}>
                            {in_gen || "New Invoice"}
                        </Typography.Text>
                        <span
                            style={{
                                background: statusStyle.bg,
                                color: statusStyle.color,
                                padding: "4px 12px",
                                borderRadius: 6,
                                fontWeight: 700,
                                fontSize: 12,
                            }}
                        >
                            {currentStatus}
                        </span>
                    </div>

                    <Space wrap>
                        <Button icon={<FilePdfOutlined />} onClick={handleDownloadInvoicePDF}>
                            Preview PDF
                        </Button>
                        <Button
                            type="primary"
                            icon={<SendOutlined />}
                            style={{ background: "#16a34a", borderColor: "#16a34a" }}
                            onClick={handleSendInvoice}
                        >
                            Send Invoice
                        </Button>
                        <Button
                            icon={<DollarOutlined />}
                            style={{ background: "#7c5cff", borderColor: "#7c5cff", color: "#fff" }}
                            onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" })}
                        >
                            Record Payment
                        </Button>
                        <Button icon={<PlusCircleOutlined />} style={{ color: "#b45309", borderColor: "#fcd34d" }}>
                            Create Credit Note
                        </Button>

                        <Button>
                            More Actions <DownOutlined />
                        </Button>

                    </Space>
                </div>

                {/* Invoice Information box */}
                <div
                    style={{
                        border: "1px solid #eef0f5",
                        borderRadius: 10,
                        padding: "5px 18px 18px",
                        background: "#fff",
                        marginBottom: 16,
                    }}
                >
                    <Typography.Title
                        level={5}
                        style={{
                            margin: "0 0 18px",
                            fontWeight: 600,
                            fontSize: 16,
                            color: primaryColor,
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        <FileTextOutlined />
                        Invoice Information
                    </Typography.Title>

                    <Form form={form} layout="vertical">
                        <Row gutter={[24, 18]}>
                            <Col xs={24} sm={12} md={4}>
                                <InfoItem label="Invoice No" value={in_gen || "-"} />
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <div>
                                    <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                                        Invoice Date
                                    </div>
                                    <DatePicker
                                        size="small"
                                        format="DD MMM YYYY"
                                        style={{ width: "100%", height: 32 }}
                                        value={invoiceDate ? dayjs(invoiceDate) : null}
                                        onChange={(v) => setInvoiceDate(v ? dayjs(v).format("YYYY-MM-DD") : "")}
                                    />
                                </div>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <div>
                                    <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                                        Due Date
                                    </div>
                                    <DatePicker
                                        size="small"
                                        format="DD MMM YYYY"
                                        style={{ width: "100%", height: 32 }}
                                        value={dueDate ? dayjs(dueDate) : null}
                                        onChange={(v) => setDueDate(v ? dayjs(v).format("YYYY-MM-DD") : "")}
                                    />
                                </div>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <InfoItem
                                    label="Status"
                                    value={
                                        <span
                                            style={{
                                                background: statusStyle.bg,
                                                color: statusStyle.color,
                                                padding: "6px 12px",
                                                borderRadius: 6,
                                                fontWeight: 700,
                                            }}
                                        >
                                            {currentStatus}
                                        </span>
                                    }
                                />
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <div>
                                    <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                                        Select Quotation
                                    </div>
                                    <Select
                                        size="small"
                                        value={selectMode}
                                        allowClear
                                        placeholder="Select Quotation"
                                        style={{ width: "100%" }}
                                        onChange={(val) => {
                                            setSelectMode(val);
                                            setEqData([]);
                                            setBasedata([]);
                                            setRowData([]);
                                            customerForm.resetFields();
                                            form.setFieldsValue({ qu_no: undefined, eq_no: undefined });
                                        }}
                                        options={[
                                            { label: "Quotation", value: "quotation" },
                                            // { label: "Enquiry", value: "enquiry" },
                                        ]}
                                    />
                                </div>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                {selectMode === "quotation" ? (
                                    <>
                                        <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                                            Select Quotation
                                        </div>
                                        <Form.Item name="qu_no" style={{ marginBottom: 0 }}>
                                            <Select
                                                showSearch
                                                allowClear
                                                placeholder="Select quotation"
                                                size="small"
                                                style={{ width: "100%" }}
                                                onChange={handleGetDataByQId}
                                                filterOption={(input, option) =>
                                                    (option?.searchtext || "").toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {Object.values(grouped).map((group) => (
                                                    <OptGroup key={group.service_name} label={group.service_name}>
                                                        {group.items.map((item) => (
                                                            <Option
                                                                key={item.qu_no}
                                                                value={item.qu_no}
                                                                searchtext={`${item.qu_no} ${item.customer_name}`}
                                                            >
                                                                {renderItem(item.qu_no, item.customer_name)}
                                                            </Option>
                                                        ))}
                                                    </OptGroup>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                                            Select Quotation
                                        </div>
                                        <Form.Item name="eq_no" style={{ marginBottom: 0 }}>
                                            <Select
                                                showSearch
                                                allowClear
                                                size="small"
                                                style={{ width: "100%" }}
                                                placeholder="Select Quotation"
                                                optionLabelProp="label"
                                                onChange={handleSelectEnquiry}
                                                filterOption={(input, option) =>
                                                    (option?.searchtext || "").toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {Object.values(groupedEnquiries).map((group) => (
                                                    <OptGroup key={group.service_name} label={group.service_name}>
                                                        {group.items.map((item) => (
                                                            <Option
                                                                key={item.eq_id}
                                                                value={item.eq_id}
                                                                label={`${item.eq_id} - ${item.name}`}
                                                                searchtext={`${item.eq_id} ${item.name}`}
                                                            >
                                                                <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                                                                    <span>{item.eq_id}</span>
                                                                    <span>
                                                                        <UserOutlined /> {item.name}
                                                                        {item.eq_status ? ` — ${item.eq_status}` : ""}
                                                                    </span>
                                                                </Flex>
                                                            </Option>
                                                        ))}
                                                    </OptGroup>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* Customer Information / Invoice Details / Payment Summary / Quick Actions — 4 cards, matching image */}
                <Row gutter={[16, 16]}>
                    {/* Customer Information */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                                <Typography.Text strong style={{ color: primaryColor, fontSize: 15 }}>
                                    <UserOutlined style={{ marginRight: 8 }} />
                                    Customer Information
                                </Typography.Text>
                                {editCustomer ? (
                                    <span>
                                        <Button type="link" size="small" onClick={saveCustomerInfo} style={{ padding: "0 4px" }}>
                                            Save
                                        </Button>
                                        <Button type="link" size="small" onClick={() => setEditCustomer(false)} style={{ padding: "0 4px" }}>
                                            Cancel
                                        </Button>
                                    </span>
                                ) : (
                                    <Button
                                        type="link"
                                        size="small"
                                        style={{ padding: 0, color: primaryColor, fontWeight: 500 }}
                                        onClick={() => setEditCustomer(true)}
                                    >
                                        Edit
                                    </Button>
                                )}
                            </div>

                            {editCustomer ? (
                                <>
                                    <EditRow label="Company Name">
                                        <Input
                                            size="small"
                                            value={customerInfo.company_name}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, company_name: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Contact Person">
                                        <Input
                                            size="small"
                                            value={customerInfo.contact_person}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, contact_person: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Mobile No">
                                        <Input
                                            size="small"
                                            value={customerInfo.mobile_no}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, mobile_no: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Email">
                                        <Input
                                            size="small"
                                            value={customerInfo.email}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, email: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="GSTIN">
                                        <Input
                                            size="small"
                                            value={customerInfo.gstin}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, gstin: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Address">
                                        <Input.TextArea
                                            rows={2}
                                            size="small"
                                            value={customerInfo.address}
                                            onChange={(e) => setCustomerInfo((p) => ({ ...p, address: e.target.value }))}
                                        />
                                    </EditRow>
                                </>
                            ) : (
                                <>
                                    {/* Company Name shown bold at top, matching the image ("Prakash Hospitality Pvt. Ltd.") */}
                                    <div style={{ fontSize: 15, fontWeight: 700, color: "#1f1f1f", marginBottom: 12 }}>
                                        {customerInfo.company_name || "-"}
                                    </div>
                                    <InfoRow label="Contact Person" value={customerInfo.contact_person} />
                                    <InfoRow label="Mobile No" value={customerInfo.mobile_no} />
                                    <InfoRow label="Email" value={customerInfo.email} />
                                    <InfoRow label="GSTIN" value={customerInfo.gstin} />
                                    <InfoRow label="Address" value={customerInfo.address} last />
                                </>
                            )}
                        </Card>
                    </Col>

                    {/* Invoice Details */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                                <Typography.Text strong style={{ color: primaryColor, fontSize: 15 }}>
                                    <FileTextOutlined style={{ marginRight: 8 }} />
                                    Invoice Details
                                </Typography.Text>
                                {editInvoiceDetails ? (
                                    <span>
                                        <Button type="link" size="small" onClick={saveInvoiceDetails} style={{ padding: "0 4px" }}>
                                            Save
                                        </Button>
                                        <Button type="link" size="small" onClick={() => setEditInvoiceDetails(false)} style={{ padding: "0 4px" }}>
                                            Cancel
                                        </Button>
                                    </span>
                                ) : (
                                    <Button
                                        type="link"
                                        size="small"
                                        style={{ padding: 0, color: primaryColor, fontWeight: 500 }}
                                        onClick={() => setEditInvoiceDetails(true)}
                                    >
                                        Edit
                                    </Button>
                                )}
                            </div>

                            {editInvoiceDetails ? (
                                <>
                                    <EditRow label="Invoice Number">
                                        <Input size="small" value={in_gen} disabled />
                                    </EditRow>
                                    <EditRow label="Invoice Date">
                                        <DatePicker
                                            size="small"
                                            style={{ width: "100%" }}
                                            format="DD MMM YYYY"
                                            value={invoiceDetails.invoice_date ? dayjs(invoiceDetails.invoice_date) : null}
                                            onChange={(v) =>
                                                setInvoiceDetails((p) => ({ ...p, invoice_date: v ? dayjs(v).format("YYYY-MM-DD") : "" }))
                                            }
                                        />
                                    </EditRow>
                                    <EditRow label="Due Date">
                                        <DatePicker
                                            size="small"
                                            style={{ width: "100%" }}
                                            format="DD MMM YYYY"
                                            value={invoiceDetails.due_date ? dayjs(invoiceDetails.due_date) : null}
                                            onChange={(v) =>
                                                setInvoiceDetails((p) => ({ ...p, due_date: v ? dayjs(v).format("YYYY-MM-DD") : "" }))
                                            }
                                        />
                                    </EditRow>
                                    <EditRow label="Reference">
                                        <Input
                                            size="small"
                                            value={invoiceDetails.reference}
                                            onChange={(e) => setInvoiceDetails((p) => ({ ...p, reference: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Project">
                                        <Input
                                            size="small"
                                            value={invoiceDetails.project}
                                            onChange={(e) => setInvoiceDetails((p) => ({ ...p, project: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Place of Supply">
                                        <Input
                                            size="small"
                                            value={invoiceDetails.place_of_supply}
                                            onChange={(e) => setInvoiceDetails((p) => ({ ...p, place_of_supply: e.target.value }))}
                                        />
                                    </EditRow>
                                    <EditRow label="Status">
                                        <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "3px 10px", borderRadius: 6, fontWeight: 600, fontSize: 11 }}>
                                            {currentStatus}
                                        </span>
                                    </EditRow>
                                    <EditRow label="Sales Executive">
                                        <Input
                                            size="small"
                                            value={invoiceDetails.sales_executive}
                                            onChange={(e) => setInvoiceDetails((p) => ({ ...p, sales_executive: e.target.value }))}
                                        />
                                    </EditRow>
                                </>
                            ) : (
                                <>
                                    <InfoRow label="Invoice Number" value={in_gen} />
                                    <InfoRow label="Invoice Date" value={dayjs(invoiceDetails.invoice_date).format("DD MMM YYYY")} />
                                    <InfoRow
                                        label="Due Date"
                                        value={invoiceDetails.due_date ? dayjs(invoiceDetails.due_date).format("DD MMM YYYY") : "-"}
                                    />
                                    <InfoRow label="Reference" value={invoiceDetails.reference} />
                                    <InfoRow label="Project" value={invoiceDetails.project} />
                                    <InfoRow label="Place of Supply" value={invoiceDetails.place_of_supply} />
                                    <InfoRow
                                        label="Status"
                                        valueNode={
                                            <span
                                                style={{
                                                    background: statusStyle.bg,
                                                    color: statusStyle.color,
                                                    padding: "2px 12px",
                                                    borderRadius: 6,
                                                    fontWeight: 600,
                                                    fontSize: 11,
                                                }}
                                            >
                                                {currentStatus}
                                            </span>
                                        }
                                    />
                                    <InfoRow label="Sales Executive" value={invoiceDetails.sales_executive} last />
                                </>
                            )}
                        </Card>
                    </Col>

                    {/* Payment Summary */}
                    {/* Payment Summary */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 15, display: "block", marginBottom: 14 }}>
                                Payment Summary
                            </Typography.Text>
                            {(() => {
                                const invoiceVal = Number(paymentSummary.grandTotal || 0);
                                const received = Number(paymentSummary.totalReceived || 0);
                                const pending = Math.max(0, invoiceVal - received);
                                const isOverdue = invoiceStatus === "Overdue";
                                const overdue = isOverdue ? pending : 0;
                                const progress = invoiceVal > 0 ? Math.min(100, Math.round((received / invoiceVal) * 100)) : 0;
                                const fmt = (v) => `₹ ${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
                                return (
                                    <>
                                        <InfoRow label="Invoice Value" value={fmt(invoiceVal)} />
                                        <InfoRow label="Received Amount" valueNode={<span style={{ fontWeight: 600, color: "#16a34a" }}>{fmt(received)}</span>} />
                                        <InfoRow label="Pending Amount" valueNode={<span style={{ fontWeight: 600, color: "#dc2626" }}>{fmt(pending)}</span>} />
                                        <InfoRow label="Overdue Amount" valueNode={<span style={{ fontWeight: 600, color: overdue > 0 ? "#dc2626" : "#1f1f1f" }}>{fmt(overdue)}</span>} last />

                                        <div style={{ marginTop: 14 }}>
                                            <Typography.Text style={{ fontSize: 13, color: "#6b7280", display: "block", marginBottom: 6 }}>
                                                Payment Progress
                                            </Typography.Text>
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <div style={{ flex: 1, height: 6, borderRadius: 4, background: "#f0f0f0", overflow: "hidden" }}>
                                                    <div style={{ width: `${progress}%`, height: "100%", background: "#16a34a" }} />
                                                </div>
                                                <Typography.Text style={{ fontSize: 12, fontWeight: 600 }}>{progress}%</Typography.Text>
                                            </div>
                                        </div>
                                    </>
                                );
                            })()}
                        </Card>
                    </Col>

                    {/* Quick Actions */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 15, display: "block", marginBottom: 14 }}>
                                Quick Actions
                            </Typography.Text>
                            <Space direction="vertical" style={{ width: "100%" }} size={8}>
                                <Button block icon={<WhatsAppOutlined />} style={{ textAlign: "left" }} onClick={handleSendWhatsApp}>
                                    Send WhatsApp
                                </Button>
                                <Button
                                    block
                                    icon={<DownloadOutlined />}
                                    style={{ textAlign: "left" }}
                                    onClick={handleDownloadInvoicePDF}
                                >
                                    Download PDF
                                </Button>
                                <Button block icon={<PrinterOutlined />} style={{ textAlign: "left" }} onClick={handlePrintInvoicePDF}>
                                    Print Invoice
                                </Button>
                                <Button block icon={<ShareAltOutlined />} style={{ textAlign: "left" }}>
                                    Share Payment Link
                                </Button>
                                <Button block icon={<SyncOutlined />} style={{ textAlign: "left" }}>
                                    Create Recurring Invoice
                                </Button>
                            </Space>
                        </Card>
                    </Col>
                </Row>

                {/* Items table */}
                <div style={{ marginTop: 16 }}>
                    <AddInvoiceData
                        key={eqData?.eq_id || baseData?.qu_no || in_gen}
                        Eqslected={Eqslected}
                        invoice_no={in_gen}
                        data={baseData}
                        eqData={eqData}
                        rowData={rowData}
                        baseData={baseData}
                        customerForm={customerForm}
                        invoiceDate={invoiceDate}
                        extraDetails={invoiceDetails}
                        onInvoiceGenerated={setInvoiceRecord}
                        invoiceId={invoiceRecord?.id ?? null}
                        invoiceRecord={invoiceRecord}
                        customerInfo={customerInfo}
                        onPaymentSummaryChange={setPaymentSummary}
                        onSendInvoice={handleSendInvoice}
                    />
                </div>
            </Card>
        </>
    );
};

export default CreateInvoice;